angular.module('ui.order.orderItemCard.orderItemComments.commentRow', [])

    .directive('commentRow', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/ui/order/orderItemCard/orderItemComments/commentRow/commentRow.html',
            scope: false
        };
    })

;